import { useQuery } from '@tanstack/react-query';

import * as partnerApi from '@/apis/partner';
import type {
  PaginationRequestParams,
  PathVariableRequestParams,
} from '@/types/api';
import type { CommonUseQueryOptions } from '@/types/app';
import type {
  GetPartnerNoticeResponse,
  GetPartnerNoticesMainResponse,
  GetProductOrderResponse,
  GetProductOrdersResponse,
  GetProductResponse,
  GetProductsResponse,
} from '@/types/partner';
import { getQueryKey } from '@/utils/queryKeys';

export const useProducts = (
  params: PaginationRequestParams,
  options?: CommonUseQueryOptions<GetProductsResponse>
) => {
  const query = useQuery({
    queryKey: getQueryKey('getProducts', params),
    queryFn: () => partnerApi.getProducts(params),
    ...options,
  });

  return query;
};

export const useProduct = (
  params: PathVariableRequestParams,
  options?: CommonUseQueryOptions<GetProductResponse>
) => {
  const query = useQuery({
    queryKey: getQueryKey('getProduct', params),
    queryFn: () => partnerApi.getProduct(params),
    ...options,
  });

  return query;
};

export const useProductOrders = (
  params: PaginationRequestParams,
  options?: CommonUseQueryOptions<GetProductOrdersResponse>
) => {
  const query = useQuery({
    queryKey: getQueryKey('getProductOrders', params),
    queryFn: () => partnerApi.getProductOrders(params),
    ...options,
  });

  return query;
};

export const useProductOrder = (
  params: PathVariableRequestParams,
  options?: CommonUseQueryOptions<GetProductOrderResponse>
) => {
  const query = useQuery({
    queryKey: getQueryKey('getProductOrder', params),
    queryFn: () => partnerApi.getProductOrder(params),
    ...options,
  });

  return query;
};

/** Notice */
export const usePartnerNoticesMain = (
  params: PaginationRequestParams,
  options?: CommonUseQueryOptions<GetPartnerNoticesMainResponse>
) => {
  const query = useQuery({
    queryKey: getQueryKey('getPartnerNoticesMain', params),
    queryFn: () => partnerApi.getPartnerNoticesMain(params),
    ...options,
  });

  return query;
};

export const usePartnerNotice = (
  params: PathVariableRequestParams,
  options?: CommonUseQueryOptions<GetPartnerNoticeResponse>
) => {
  const query = useQuery({
    queryKey: getQueryKey('getPartnerNotice', params),
    queryFn: () => partnerApi.getPartnerNotice(params),
    ...options,
  });

  return query;
};
